import { Injectable } from '@angular/core';
import { catchError, switchMap, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { UserSettingsEntitiesService } from '../../services/user-settings-entities.service';
import { UserSettingsEntityActions } from './user-settings-entity.actions';
import { UserSettingsActions } from '../user-settings/user-settings.actions';
import { MessagesActions } from 'src/app/core/store/messages/messages.actions';
import { EntityTypeKey } from 'src/app/shared/constants/entity-type-keys';

@Injectable()
export class UserSettingsEntityEffects {
  constructor(private actions$: Actions, private userSettingsEntitiesService: UserSettingsEntitiesService) {}

  getUserSettingsEntityStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserSettingsEntityActions.get_entity_start),
        switchMap(() =>
          this.userSettingsEntitiesService.getUserSettingsEntity().pipe(
            switchMap(entities => {
              return [
                UserSettingsEntityActions.get_entity_success({ entity: entities.find(x => x.EntityTypeKey === 'UserSettings') }),
                MessagesActions.set_message_entites({ entities: entities.filter(x => x.EntityTypeKey === EntityTypeKey.Message) })
              ];
            }),
            catchError(error => of(UserSettingsEntityActions.get_entity_fail({ error: error })))
          )
        )
      ),
    { dispatch: true }
  );

  updateUserSettingsEntityStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserSettingsEntityActions.update_entity_start),
        switchMap(action =>
          this.userSettingsEntitiesService.updateUserSettingsEntity(action.settings).pipe(
            switchMap(entities => {
              return [
                UserSettingsEntityActions.get_entity_success({ entity: entities.find(x => x.EntityTypeKey === 'UserSettings') }),
                MessagesActions.set_message_entites({ entities: entities.filter(x => x.EntityTypeKey === EntityTypeKey.Message) })
              ];
            })
          )
        )
      ),
    { dispatch: true }
  );

  getUserSettingsEntitySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserSettingsEntityActions.get_entity_success),
        map(() => UserSettingsActions.get_user_settings_start())
      ),
    { dispatch: true }
  );

  getUserSettingsEntityFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserSettingsEntityActions.get_entity_fail),
        tap(data => {
          throw data.error;
        })
      ),
    { dispatch: false }
  );
}
